import React from "react";
import { motion } from "framer-motion";

const pillars = [
    {
        num: "I",
        title: "The Golden Hour",
        text: "33 Emergency Medical Rooms across Mumbai's railway network — stabilising trauma, cardiac, and obstetric emergencies in the first 60 minutes, when survival depends on speed.",
        color: "bisleri",
    },
    {
        num: "II",
        title: "The Integrated Pharmacy",
        text: "A discount pharmacy attached to every clinic. Branded and generic medicines at 50% average reduction — because diagnosis without affordable treatment is a half-broken promise.",
        color: "clinicgreen",
    },
    {
        num: "III",
        title: "Public-Private Trust",
        text: "Trusted partner to Central & Western Railways, KDMC, PMC, MBMC, TMC, and Vedanta Medical College — proving that humanitarian medicine and institutional rigour belong together.",
        color: "bisleri",
    },
];

const Mission = () => {
    return (
        <section
            id="mission"
            data-testid="mission-section"
            className="relative py-24 md:py-32 lg:py-40 bg-mint-soft border-y border-ink-900/8"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-8">
                    <div className="col-span-12 lg:col-span-4">
                        <div className="section-number">02 / Mission</div>
                        <div className="mt-6 divider" />
                        <div className="mt-4 eyebrow">One Rupee Clinic</div>
                    </div>

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
                        className="col-span-12 lg:col-span-8"
                    >
                        <h2 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-[96px] leading-[0.95] tracking-tighter text-ink-900">
                            Affordable<br />
                            &amp; Quality<br />
                            Healthcare <em className="text-bisleri">for All.</em>
                        </h2>
                        <p className="mt-8 font-body text-lg md:text-xl text-ink-700 max-w-2xl leading-relaxed">
                            A single, defiant sentence — written into the wall of every
                            One Rupee Clinic from Kalwa to Worli. A mission to expand
                            pan-India, until no citizen is deprived of medical care
                            because of cost.
                        </p>
                    </motion.div>
                </div>

                <div className="mt-20 md:mt-28 grid grid-cols-12 gap-6 md:gap-8">
                    {pillars.map((p, i) => (
                        <motion.div
                            key={p.num}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 1, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                            className="col-span-12 md:col-span-4 bg-paper-50 p-8 md:p-10 lg:p-12 border border-ink-900/8 hover:border-bisleri/40 hover:shadow-2xl hover:shadow-bisleri/5 hover:-translate-y-1 transition-all duration-500"
                            data-testid={`mission-pillar-${i + 1}`}
                        >
                            <div className={`font-display text-7xl md:text-8xl leading-none ${p.color === "clinicgreen" ? "text-clinicgreen/30" : "text-bisleri/25"}`}>
                                {p.num}
                            </div>
                            <h3 className="mt-6 font-display italic text-2xl md:text-3xl text-ink-900">
                                {p.title}
                            </h3>
                            <p className="mt-4 font-body text-sm md:text-base text-ink-700 leading-relaxed">
                                {p.text}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Mission;
